import { render, staticRenderFns } from "./HeaderUserInfo.vue?vue&type=template&id=06e7fc19&scoped=true&"
import script from "./HeaderUserInfo.vue?vue&type=script&lang=ts&"
export * from "./HeaderUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderUserInfo.vue?vue&type=style&index=0&id=06e7fc19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7fc19",
  null
  
)

export default component.exports